import React, { ReactNode } from 'react';

import { margin, useClassnames } from '@lumapps/classnames';
import { mdiSparkles } from '@lumapps/lumx/icons';
import { ColorPalette, ColorVariant, FlexBox, Icon, Placement, Size, Text } from '@lumapps/lumx/react';
import { GLOBAL, useTranslate } from '@lumapps/translations';

import { ASK_AI } from '../../keys';
import { AskSearchBestAnswer } from '../../types';
import { AskAiHumanCuratedDisclaimer } from '../AskAiHumanCuratedDisclaimer/AskAiHumanCuratedDisclaimer';

import './index.scss';

interface AskAiDisclaimer {
    isHumanCurated?: AskSearchBestAnswer['isHumanCurated'];
    customDisclaimerMessage?: ReactNode;
    isWebview?: boolean;
}

const CLASSNAME = 'ask-ai-disclaimer';

export const AskAiDisclaimer: React.FC<AskAiDisclaimer> = ({
    isHumanCurated,
    customDisclaimerMessage,
    isWebview = false,
}) => {
    const { translateKey } = useTranslate();
    const { element } = useClassnames(CLASSNAME);

    return isHumanCurated ? (
        <AskAiHumanCuratedDisclaimer />
    ) : (
        customDisclaimerMessage || (
            <FlexBox orientation="horizontal" hAlign="center">
                <Icon className={margin(Placement.RIGHT, Size.tiny)} icon={mdiSparkles} size="xxs" />
                <Text as="p" typography="caption" color={ColorPalette.dark} colorVariant={ColorVariant.L2}>
                    <Text as="span" className={element('bold-disclaimer')}>
                        {isWebview ? translateKey(GLOBAL.ASK_AI) : translateKey(ASK_AI.AI_ANSWER)}{' '}
                    </Text>
                    {!isWebview && translateKey(GLOBAL.RESULT_GENERATED_BY_AI)}
                </Text>
            </FlexBox>
        )
    );
};
